<template>
  <div class="rfid-info pa-10">

    <div class="d-flex justify-end">
      <audit-trail-button entity-type="Token" :entity-id="$route.params.id" />
    </div>

    <headline>
      {{ $tc('rfid.rfid') }}
    </headline>

    <div class="grid">
      <v-row>
        <v-col class="label" sm="3">
          {{ $t('rfid.rfid-card-no') }} :
        </v-col>
        <v-col sm="3">
          {{ token.uid}}
          <badge-origin-chip :token="token" class="ml-2" />
          <v-btn class="ml-5" small :to="{name: 'tokens.edit', params: {id: token.id}}" v-if="currentUser.permissions.includes('OPERATOR_WRITE')">
            <v-icon left>mdi-cog</v-icon>
            {{ $t('edit')}}
          </v-btn>
        </v-col>
        <v-col class="label" sm="3">
          {{ $t('rfid.rfid-card-name') }} :
        </v-col>
        <v-col sm="3">
          {{ token.name}}
        </v-col>
        <v-col class="label" sm="3">
          {{ $t('rfid.rfid-card-physical-reference') }} :
        </v-col>
        <v-col sm="3">
          {{ token.physicalReference}}
        </v-col>
        <v-col class="label" sm="3">
          {{ $t('rfid.rfid-card-enabled') }} :
        </v-col>
        <v-col sm="3">
          <div class="switch">
            <v-switch
                readonly
                color="#00897E"
                inset
                hide-details
                v-model="token.enabled"
            />
          </div>
        </v-col>
        <template v-if="!token.enabled && token.deactivationReason">
          <v-col class="label" sm="3">
            {{ $t('rfid.deactivation-reason') }} :
          </v-col>
          <v-col sm="3">
            {{ $t(`rfid.deactivation-reason-${token.deactivationReason}`) }}<template v-if="token.deactivationNote"> — {{ token.deactivationNote }}</template>
          </v-col>
        </template>
        <v-col class="label" sm="3">
          {{ $t('rfid.rfid-corporate') }} :
        </v-col>
        <v-col sm="3">
          <div class="switch">
            <v-switch
                readonly
                color="#00897E"
                inset
                hide-details
                v-model="token.corporate"
            />
          </div>
          <!-- Coché pro, en attente de l'accord de la personne : il reste personnel jusque-là. -->
          <div v-if="token.professionalRequest" class="text-caption warning--text">
            {{ $t('rfid.professional-consent.pending', { name: holderName(token), date: $options.filters.formatDate(token.professionalRequest.requestedAt) }) }}
          </div>
        </v-col>
        <v-col class="label" sm="3">
          {{ $tc('customer.customer', 1) }} :
        </v-col>
        <v-col sm="3">
          <router-link v-if="token?.customer?.id" :to="{ name: 'customer.detail', params: { id: token.customer.id } }">{{ token.customer.lastname }} {{ token.customer.firstname }}</router-link>
        </v-col>
        <v-col class="label" sm="3">
          {{ $tc('organization.organization', 1) }} :
        </v-col>
        <v-col sm="3">
          <router-link v-if="token?.organization?.id" :to="{ name: 'organizations.detail', params: { id: token.organization.id } }">{{ token.organization.name }}</router-link>
        </v-col>
        <v-col class="label" sm="3">
          {{ $t('rfid.assigned-vehicle') }} :
        </v-col>
        <v-col sm="3">{{ tokenVehicleLabel }}</v-col>
      </v-row>

    </div>
  </div>
</template>

<script>
import AuditTrailButton from "@elements/AuditTrailButton.vue";
import BadgeOriginChip from '@elements/BadgeOriginChip.vue'
import { holderName } from '../professionalConsent'

export default {
  components: {AuditTrailButton,  BadgeOriginChip },
  computed: {
    token() {
      return this.$parent.token ?? null
    },

    tokenVehicleLabel() {
      const v = this.token?.vehicle
      if (!v) return '-'
      const left = v.registrationNumber || v.name
      const right = [v.brand, v.model].filter(Boolean).join(' ')
      return [left, right].filter(Boolean).join(' · ') || '-'
    },
  },

  methods: { holderName },
}
</script>

<style lang="scss">
.charging-point-type-info {
  .evses {
    .row {
      margin: -4px;
      &  + .row {
        margin-top: 4px;
      }
      & > .col, & > [class*=col-] {
        padding: 4px;
        &:not(.label) {
          justify-content: center;
        }
      }
    }
    .v-expansion-panel {
      background: white;
    }
    .evse {
      //border: 1px dotted #ccc;
      border-radius: 10px;
      padding: 0 20px;
      .sub-headline {
        margin: 20px 0;
        font-weight: 500;
      }
      .physical-reference {
        border: 2px solid var(--v-primary-base);
        color: var(--v-primary-base);
        border-radius: 15px;
        padding: 0px 10px;
        font-size: 16px;
        line-height: 22px;
        height: 26px;
        font-weight: bold;
        box-shadow: 0 0 15px #e53c225e;

      }
      .connectors {
        .connector {
          margin: 0 30px;
          border-radius: 10px;
          .grid {
            .headline-title {
              .col {
                color: var(--v-primary-base);
                font-weight: 600;
                display: flex;
                align-items: center;
              }
            }
          }
        }
      }
    }
  }
}

</style>
